import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const History = lazy(() => import('../../views/parking/history/history'))
const ZonesAdmin = lazy(() => import('../../views/parking/zones-admin'))
const SubzoneAdmin = lazy(() => import('../../views/parking/subzone-admin'))
const AreaAdmin = lazy(() => import('../../views/parking/areas-admin'))

const ParkingRoutes = [
  //history tickets

  {
    element: <History />,
    path: '/parking/list',
    meta: {
      action: 'concesion-level-1',
      resource: 'tollSystem'
    }
  },
  {
    element: <ZonesAdmin />,
    path: '/parking/zones',
    meta: {
      action: 'concesion-level-1',
      resource: 'tollSystem'
    }
  },
  {
    element: <SubzoneAdmin />,
    path: '/parking/subzone',
    meta: {
      action: 'concesion-level-1',
      resource: 'tollSystem'
    }
  },
  {
    element: <AreaAdmin />,
    path: '/parking/area',
    meta: {
      action: 'concesion-level-1',
      resource: 'tollSystem'
    }
  }
]

export default ParkingRoutes
